var CSSView = Control.extend({
	init: function(p) {
		this.base('div', p);
		this.setAttribute('layout', 'cssview')
		this.classList.add('cssview');
	},
	text: {
		get: function() {
			return(this.hightlightarea.text);
		},
		set: function(value) {
			this.hightlightarea.text = value;
		}
	}
});